(function () {
    'use strict';

    var core = angular.module('app.core');

    core.config(toastrConfig);

    toastrConfig.$inject = ['toastr'];
    /* @ngInject */
    function toastrConfig(toastr) {
        toastr.options.timeOut = 4000;
        toastr.options.positionClass = 'toast-bottom-right';
    }

    var keyCodes = {
        backspace: 8,
        tab: 9,
        enter: 13,
        esc: 27,
        space: 32,
        pageup: 33,
        pagedown: 34,
        end: 35,
        home: 36,
        left: 37,
        up: 38,
        right: 39,
        down: 40,
        insert: 45,
        del: 46
    };

    var events = {
        refreshCounts: 'sidebar.refreshCounts',
        authenticationChange: 'authentication.change',
        mainDateChange: 'mainDate.change',
        userConfigOptionsChange: 'userConfigOptions.change',
        signalRStatusChange: 'signalRStatus.change',
        filterCleared: 'st-search.cleared',
        stateChanged: 'state.changed',
        mainDateToday: 'mainDate.today'
    };

    var apiTypes = {
        sevenPoint: 'BCA944F7-7795-45CD-A21B-CB5F16DC4175',
        ems: '4CF523BF-F6DD-441C-810F-C87347963B5D',
        collegeNet: '355A9B3B-BF7E-4D96-8B06-27B310EB01F0',
        centersXml: '4D2BFEBD-7631-4AEE-96CF-392CFA0BFB3A',
        adAstra: '5C088F8B-7D16-4C06-B691-7E6FCD4344AD',
        mazevo: '0E9DADB2-F56B-4E7E-A3B2-A59632C91D86'
    };

    var displayTypes = {
        eventDisplay: 'f72e8f09-a1cd-4066-9273-5cd292c9f47d',
        roomCard: '2bacc947-4ee0-4be6-9810-f623264e6354',
        pictureBox: '360e8227-4927-4e14-9cef-2f4127cb4b21'
    };

    var config = {
        appErrorPrefix: '[7 Point Error] ',
        appTitle: '7 Point Ops',
        keyCodes: keyCodes,
        events: events,
        apiTypes: apiTypes,
        displayTypes: displayTypes
    };

    core.constant('config', config);

    core.config(configure);

    configure.$inject = ['$logProvider', '$httpProvider', '$compileProvider', 'routerHelperProvider', 'exceptionHandlerProvider'];
    /* @ngInject */
    function configure($logProvider, $httpProvider, $compileProvider, routerHelperProvider, exceptionHandlerProvider) {

        $compileProvider.debugInfoEnabled(false);

        if ($logProvider.debugEnabled) {
            $logProvider.debugEnabled(false);
        }
        exceptionHandlerProvider.configure(config.appErrorPrefix);
        routerHelperProvider.configure({ docTitle: config.appTitle + ': ' });

        $httpProvider.interceptors.push('AjaxInterceptor');
    }

})();
